<script>
import {mapActions, mapMutations, mapState} from "vuex";
import DialogContractHostel from "../../Dialogs/DialogContractHostel.vue"
import HostelContractPDF from "../../../../../makepdfs/statement_hostel/stm_hostel_contract_pdf";

export default {
  name: "CardLastStmHostel",
  components:{
    DialogContractHostel
  },
  data: () => ({

  }),
  computed: {
    ...mapState({
      last_actual_statement: state => state.interactionStatement.last_actual_statement,
    }),
    result_place(){
      if (this.last_actual_statement.result_place){
        return this.last_actual_statement.result_place.name_hostel + " | " + this.last_actual_statement.result_place.name_room
      }
    },
    status_order(){
      if (this.last_actual_statement?.hostel_order_id === null){
        return { text: "Отсутствует", color: 'orange' }
      } else return {text: this.last_actual_statement?.hostel_order_id, color: 'teal' }
    }
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
      viewContractHostel(){
        HostelContractPDF.createPDF(
            this.last_actual_statement.contract_hostel.data_contract.full_name,
            this.last_actual_statement.contract_hostel.data_contract.name_hostel,
            this.last_actual_statement.contract_hostel.data_contract.name_section,
            this.last_actual_statement.contract_hostel.data_contract.name_room,
            this.last_actual_statement.contract_hostel.data_contract.registration_address,
            this.last_actual_statement.contract_hostel.data_contract.identity_card,
            this.last_actual_statement.contract_hostel.data_contract.selected_devices
        );
      }
    }),
    setColorCommission(commission) {
      if (commission.status_review === 2) {
        return 'green'
      } else if (commission.status_review === 3) return 'red'

      return 'orange'
    },
  },
}
</script>

<template>
  <v-card elevation="0" outlined rounded="xl" min-width="100%">
    <v-card-title>
      <h6
        class="mx-auto text-caption text-uppercase text--secondary"
      >
        Последнее согласованное заявление
      </h6>
    </v-card-title>
    <v-card-text style="height: calc(100% - 50px);" v-if="Object.keys(last_actual_statement).length > 0">
      <v-card
        style="height: calc(100% - 50px);"
        elevation="0"
        min-height="100%"
        min-width="100%"
      >
        <v-card-title>
          <div class="text-h6 mx-auto">
            Заявление № {{ last_actual_statement.id }}
          </div>
          <v-row
              class="mb-4"
              no-gutters
              justify="center"
          >
            <div
                v-for="(commission, index) in last_actual_statement.commission_statuses"
                :key="index"
                class="group mt-2 mx-2"
            >
              <v-chip
                  :color="setColorCommission(commission, index)"
                  outlined
              >
                <v-icon>
                  fa-user-circle
                </v-icon>
              </v-chip>
            </div>
          </v-row>
        </v-card-title>
        <v-card-text class="d-flex align-center justify-center">
          <table class="text-subtitle-1">
            <tr>
              <td
                  class="pe-4"
                  :style="{ color: status_order.color }"
              >
                Приказ:
              </td>
              <td
                  :style="{ color: status_order.color }"
              >
                {{ status_order.text }}
              </td>
            </tr>
            <tr>
              <td class="pe-4">Место:</td>
              <td>{{ result_place }}</td>
            </tr>
            <tr>
              <td class="pe-4">Тип заявления:</td>
              <td>{{ last_actual_statement.statement_type }}</td>
            </tr>
            <tr>
              <td class="pe-4">Дата подачи:</td>
              <td>{{ last_actual_statement.created_at }}</td>
            </tr>
          </table>
        </v-card-text>
        <v-card-actions style="height: calc(100% - 225px);">
          <v-btn
            class="mx-auto"
            @click="viewContractHostel()"
            color="teal darken-1"
            outlined
            rounded
          >
            Перейти к договору
          </v-btn>
          <DialogContractHostel/>
        </v-card-actions>
      </v-card>
    </v-card-text>
    <v-card-text v-else class="d-flex align-center justify-center" style="height: calc(100% - 50px);">
      <v-alert
        outlined
        rounded="xl"
        color="teal"
        dark
        dense
        icon="fa-info"
        prominent
      >
        Последнее согласованное заявление <strong>отсутствует</strong>.
        Подайте заявление или дождитесь конца рассмотрения текущего заявления.
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>